'use strict';

const { etfEquityQuoteGrid } = require('./etfEquityQuoteGrid.js');
const { equityOptionQuoteGrid } = require('./equityOptionQuoteGrid.js');
const { forexQuoteGrid } = require('./forexQuoteGrid.js');
const { fundQuoteGrid } = require('./fundQuoteGrid.js');
const { futureQuoteGrid } = require('./futureQuoteGrid.js');
const { indexQuoteGrid } = require('./indexQuoteGrid.js');
const { rateQuoteGrid } = require('./rateQuoteGrid.js');

module.exports.quoteGrid = function () {
    return `
        <div id='m-quote-media-ticker-chart--quote-grid' class="qmod-quotegrid" style='display: none;'>
            ${etfEquityQuoteGrid()}
            ${forexQuoteGrid()}
            ${indexQuoteGrid()}
            ${fundQuoteGrid()}
            ${equityOptionQuoteGrid()}
            ${futureQuoteGrid()}
            ${rateQuoteGrid()}
            <div class="qmod-popup" rv-show="data.popup.show" rv-style="data.popup.style">
                <div class="qmod-popup-title">
                    {data.popup.data.title}
                    <div class="qmod-popup-titlebar-buttons">
                        <button class="qmod-btn" rv-on-click="data.popup.close">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>
                <div class="qmod-popup-body" rv-html="data.popup.data.body"></div>
            </div>
        </div>
    `;
};
